import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import GUI from 'lil-gui'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { GroundedSkybox } from 'three/addons/objects/GroundedSkybox.js';

/* STARTER BEGIN*/
//CREATE SCENE
const scene = new THREE.Scene();
const canvas = document.querySelector('canvas.webgl');

const gui = new GUI()
gui.close()


//ADD LIGHTING



// const light1 = new THREE.SpotLight(0xffffff, 3000)
// const light2 = new THREE.SpotLight(0xffffff, 3000)
// const light3 = new THREE.SpotLight(0xffffff, 6000)
// light1.castShadow = true
// light2.castShadow = true
// light3.castShadow = true
const light = new THREE.DirectionalLight(0xf1ece2, 4)
light.position.set(2,10,5)
light.castShadow = true
light.shadow.radius = 2
light.shadow.bias = -0.01;
light.shadow.blurSamples = 8
light.shadow.mapSize.width = 512; // default
light.shadow.mapSize.height = 512; // default

light.shadow.camera.near = 1
light.shadow.camera.far = 20
light.shadow.camera.left = -15
light.shadow.camera.right = 15
light.shadow.camera.top = 15
light.shadow.camera.bottom = -15

const directionalLightCameraHelper = new THREE.CameraHelper(light.shadow.camera)
scene.add(directionalLightCameraHelper)
directionalLightCameraHelper.visible = false
scene.add(light)
// gui.add(light.shadow, 'radius').min(1).max(100).step(0.1)
// gui.add(light.shadow,'blurSamples').min(1).max(50).step(1)



// light1.position.set(5,50,2);
// light2.position.set(-5,50,-2);
// light3.position.set(2,55,20);
const ambientLight = new THREE.AmbientLight(0x9A7347, 0.3)
// scene.add(light1, light2, light3);
scene.add(ambientLight)

const loadingManager = new THREE.LoadingManager()
loadingManager.onLoad = () => {
    console.log(`onLoad`)
}

/**
 * ENVIRONMENT MAP
 */
const rgbeLoader = new RGBELoader(loadingManager)
rgbeLoader.load('/textures/environment/construction_yard_4k.hdr', (environmentMap) => {
  console.log(environmentMap)
    //after it's loaded
    environmentMap.mapping = THREE.EquirectangularReflectionMapping

    const skybox = new GroundedSkybox( environmentMap, 15, 120 );
    skybox.position.y = 15 - 0.05;
    scene.add( skybox );

})

// //cubemap
// const path = 'textures/env_cube_map/';
// const format = '.png';
// const urls = [
//   path + 'px' + format, path + 'nx' + format,
//   path + 'py' + format, path + 'ny' + format,
//   path + 'pz' + format, path + 'nz' + format
// ];

// const reflectionCube = new THREE.CubeTextureLoader().load( urls );
// const refractionCube = new THREE.CubeTextureLoader().load( urls );
// refractionCube.mapping = THREE.CubeRefractionMapping;

// scene.background = reflectionCube;
// function getTexturesFromAtlasFile( atlasImgUrl, tilesNum ) {

//   const textures = [];

//   for ( let i = 0; i < tilesNum; i ++ ) {

//     textures[ i ] = new THREE.Texture();

//   }
//   console.log(atlasImgUrl)
//   new THREE.ImageLoader()
//     .load( atlasImgUrl, ( image ) => {

//       let canvas, context;
//       const tileWidth = image.height;

//       for ( let i = 0; i < textures.length; i ++ ) {

//         canvas = document.createElement( 'canvas' );
//         context = canvas.getContext( '2d' );
//         canvas.height = tileWidth;
//         canvas.width = tileWidth;
//         context.drawImage( image, tileWidth * i, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth );
//         textures[ i ].colorSpace = THREE.SRGBColorSpace;
//         textures[ i ].image = canvas;
//         textures[ i ].needsUpdate = true;

//       }

//     } );

//   return textures;

// }
// const textures = getTexturesFromAtlasFile( 'textures/environment/industrial.png', 6 );
// console.log(textures)

// const materials = [];

// for ( let i = 0; i < 6; i ++ ) {

//   materials.push( new THREE.MeshBasicMaterial( { map: textures[ i ] } ) );

// }

// const skyBox = new THREE.Mesh( new THREE.BoxGeometry( 1, 1, 1 ), materials );
// skyBox.geometry.scale(100, 100,  -100 );
// skyBox.rotation.x = Math.PI /2
// skyBox.position.y = 50
// scene.add( skyBox );


//ADD CAMERA
const camera = new THREE.PerspectiveCamera(50, window.innerWidth/window.innerHeight, 0.1, 1000);
camera.position.z = 20;
camera.position.y = 10;
camera.position.x = -3;
camera.position.x = Math.cos(0.8) * -20
camera.position.z = Math.sin(0.8) * -20 


scene.add(camera);

//ADD RENDERER
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true
});
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.shadowMap.enabled = true;
// renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.shadowMap.type = THREE.VSMShadowMap;
// renderer.shadowMap.type = THREE.PCFShadowMap


//HANDLE RESIZING
const updateWindowSize = () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}
updateWindowSize();
window.onresize = updateWindowSize;

//HANDLE FULLSCREEN
const handleFullscreen = () => {
  //browser support
  const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement
  if (!fullscreenElement) {
    //go fullscreen
    if(canvas.requestFullscreen){
      canvas.requestFullscreen();
    } else if(canvas.webkitRequestFullscreen) {
      canvas.webkitRequestFullscreen();
    }
    
  } else {
    //leave fullscreen
    if(document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
    
  }
}
window.ondblclick = handleFullscreen

//ADD ORBIT CONTROLS
const controls = new OrbitControls( camera, renderer.domElement );
controls.enableDamping = true;
controls.enableZoom = true;
controls.enablePan = true;
controls.maxPolarAngle = Math.PI /2 - 0.2
controls.maxDistance = 20
controls.minDistance = 10
controls.maxTargetRadius = 10
// controls.enabled = false;

// //ADD AXESHELPER
// const axesHelper = new THREE.AxesHelper(3);
// scene.add(axesHelper);


const textureLoader = new THREE.TextureLoader()
const albedoTexture = textureLoader.load('/textures/plywood/albedo2.jpg')
const normalTexture = textureLoader.load('/textures/plywood/normal2.jpg')
const roughnessTexture = textureLoader.load('/textures/plywood/roughness2.jpg')
const metalnessTexture = textureLoader.load('/textures/plywood/metalness2.jpg')
const aoTexture = textureLoader.load('/textures/plywood/ao2.jpg')

// const flooralbedoTexture = textureLoader.load('/textures/concrete/albedo2.jpg')
// const floornormalTexture = textureLoader.load('/textures/concrete/normal2.jpg')
// const floorroughnessTexture = textureLoader.load('/textures/concrete/roughness2.jpg')
// const floormetalnessTexture = textureLoader.load('/textures/concrete/metalness2.jpg')
// const flooraoTexture = textureLoader.load('/textures/concrete/ao2.jpg')

albedoTexture.colorSpace = THREE.SRGBColorSpace
// albedoTexture.minFilter = THREE.NearestFilter
// albedoTexture.magFilter = THREE.NearestFilter
albedoTexture.generateMipmaps = true
albedoTexture.repeat.y = 8
albedoTexture.offset.x = 0.3
albedoTexture.repeat.x = 0.5
albedoTexture.wrapT = THREE.RepeatWrapping
albedoTexture.wrapS = THREE.RepeatWrapping

// flooralbedoTexture.colorSpace = THREE.SRGBColorSpace
// flooralbedoTexture.minFilter = THREE.NearestFilter
// // flooralbedoTexture.magFilter = THREE.NearestFilter
// flooralbedoTexture.generateMipmaps = false
// flooralbedoTexture.repeat.x = 40 
// flooralbedoTexture.repeat.y = 40

// flooralbedoTexture.wrapT = THREE.RepeatWrapping
// flooralbedoTexture.wrapS = THREE.RepeatWrapping


const albedos = []
albedos[0] = albedoTexture.clone()
albedos[0].offset.x = 0.2
albedos[1] = albedoTexture.clone()
albedos[1].offset.x = 0.4
albedos[2] = albedoTexture.clone()
albedos[2].offset.x = 0.6
albedos[3] = albedoTexture.clone()
albedos[3].offset.x = 0.8
albedos[4] = albedoTexture.clone()
albedos[4].offset.x = 0
albedos[5] = albedoTexture.clone()
albedos[5].offset.x = 0.5


//add objects

/* STARTER END */

// //background
// const surfaceGeo = new THREE.PlaneGeometry(1000, 1000, 1, 1)
// const surfaceMat = new THREE.MeshLambertMaterial()
// surfaceMat.map = flooralbedoTexture
// surfaceMat.aoMap = flooraoTexture
// surfaceMat.metalnessMap = floormetalnessTexture
// surfaceMat.normalMap = floornormalTexture
// surfaceMat.roughnessMap = floorroughnessTexture
// surfaceMat.aoMapIntensity = 5
// // surfaceMat.normalScale.set(10, 10)

// const surface = new THREE.Mesh(surfaceGeo, surfaceMat);
// surface.rotation.x = -Math.PI /2
// surface.receiveShadow = true;
// scene.add(surface)

//shadow material
const geometry = new THREE.PlaneGeometry( 2000, 2000 );
geometry.rotateX( - Math.PI / 2 );

const material = new THREE.ShadowMaterial();
material.opacity = 0.5;

const shadowPlane = new THREE.Mesh( geometry, material );
shadowPlane.receiveShadow = true;
scene.add( shadowPlane );

//other objects

const boardGeo = new THREE.BoxGeometry(1,1,1);
boardGeo.translate(0.5,0.5,0.5)
const boardMat = new THREE.MeshLambertMaterial({
  color: 0xE1C594,
  wireframe: false,
  flatShading: false,
})




boardMat.map = albedos[0]
boardMat.aoMap = aoTexture
boardMat.aoMapIntensity = 5
boardMat.metalnessMap = metalnessTexture
boardMat.roughnessMap = roughnessTexture
boardMat.roughness = 1
boardMat.normalMap = normalTexture
boardMat.normalScale.set(10, 10)

const mats = []
mats[0] = boardMat.clone()
mats[0].map = albedos[Math.floor(Math.random() * 6)]
mats[1] = boardMat.clone()
mats[1].map = albedos[Math.floor(Math.random() * 6)]
mats[2] = boardMat.clone()
mats[2].map = albedos[Math.floor(Math.random() * 6)]
mats[3] = boardMat.clone()
mats[3].map = albedos[Math.floor(Math.random() * 6)]
mats[4] = boardMat.clone()
mats[4].map = albedos[Math.floor(Math.random() * 6)]
mats[5] = boardMat.clone()
mats[5].map = albedos[Math.floor(Math.random() * 6)]




const palletData = {
  'size': {
    'length': 1200,
    'width' : 1000
  },
  'top': {
    'boardType' : '16x75',
    'height': 16 / 100,
    'width' : 75 / 100,
    'length': 1200 / 100,
    'count' : 5
  },
  'stringer':{
    'boardType' : '16x75',
    'height': 16 / 100,
    'width' : 75 / 100,
    'length': 1000 / 100,
    'count' : 5
  },
  'bottom':{
    'boardType' : '18x90',
    'height': 18 / 100,
    'width' : 90 / 100,
    'length': 1200 / 100,
    'count' : 3
  },
  'block':{
    'height': 75 / 100,
    'width' : 75 / 100,
    'length': 90 / 100,
    'count' : 3
  },
}

const calculatePalletData = () => {
  //calculate gaps
  palletData.top.gap = (palletData.stringer.length - (palletData.top.width * palletData.top.count)) / (palletData.top.count - 1) + palletData.top.width
  palletData.bottom.gap = (palletData.stringer.length - (palletData.bottom.width * palletData.bottom.count)) / (palletData.bottom.count - 1) + palletData.bottom.width
  palletData.stringer.gap = (palletData.top.length - (palletData.stringer.width * palletData.stringer.count)) / (palletData.stringer.count - 1) + palletData.stringer.width
  palletData.block.gap = (palletData.bottom.length - (palletData.block.width * palletData.block.count)) / (palletData.block.count - 1) + palletData.block.width

  //calculate heights
  palletData.bottom.base = 0
  palletData.block.base = palletData.bottom.base + palletData.bottom.height
  palletData.stringer.base = palletData.block.base + palletData.block.height
  palletData.top.base = palletData.stringer.base + palletData.stringer.height
}

calculatePalletData()

const createBlock = () => {

  const blockMesh = new THREE.Mesh(boardGeo, mats[Math.floor(Math.random() * 6)])
  blockMesh.scale.set(palletData.block.width, palletData.block.height, palletData.block.length)
  blockMesh.castShadow = true
  blockMesh.receiveShadow = true
  return blockMesh
}

const createSingleLeg = () => {
  const singleLegGroup = new THREE.Group()

  const legMesh = new THREE.Mesh(boardGeo,  mats[Math.floor(Math.random() * 6)])
  legMesh.castShadow = true
  legMesh.receiveShadow = true
  legMesh.scale.set(palletData.bottom.width, palletData.bottom.height, palletData.bottom.length)
  // legMesh.castShadow = true
  singleLegGroup.add(legMesh)

  for (let i = 0; i < palletData.block.count; i++) {
    const blockMesh = createBlock()
    blockMesh.rotation.y = Math.PI /2
    blockMesh.position.y = palletData.block.base
    blockMesh.position.z = palletData.bottom.length - palletData.block.gap * i
    singleLegGroup.add(blockMesh)
  }


  return singleLegGroup
}

const createLegs = () => {
  const legGroup = new THREE.Group()
  for (let i = 0; i < palletData.bottom.count; i++) {
    const legMesh = createSingleLeg()
    //move leg and rotate
    legMesh.position.x = palletData.bottom.gap * i

    legGroup.add(legMesh)
  }
  return legGroup
}

const createSingleStringer = () => {

  const stringerMesh = new THREE.Mesh(boardGeo,  mats[Math.floor(Math.random() * 6)])
  stringerMesh.scale.set(palletData.stringer.width, palletData.stringer.height, palletData.stringer.length)
  stringerMesh.castShadow = true
  stringerMesh.receiveShadow = true
  return stringerMesh
}

const createStringers = () => {
  const stringerGroup = new THREE.Group()
  for (let i = 0; i < palletData.stringer.count; i++) {
    const stringerMesh = createSingleStringer()
    stringerMesh.position.x = palletData.stringer.gap * i
    stringerGroup.add(stringerMesh)
  }
  stringerGroup.position.y = palletData.stringer.base
  stringerGroup.rotation.y = Math.PI / 2
  stringerGroup.position.z = palletData.top.length
  return stringerGroup
}

const createSingleTop = () => {

  const topMesh = new THREE.Mesh(boardGeo,  mats[Math.floor(Math.random() * 6)])
  topMesh.scale.set(palletData.top.width, palletData.top.height, palletData.top.length)
  topMesh.castShadow = true
  topMesh.receiveShadow = true
  return topMesh
}

const createTop = () => {
  const topGroup = new THREE.Group()
  for (let i = 0; i<palletData.top.count; i++) {
    const topMesh = createSingleTop()
    topMesh.position.x = palletData.top.gap * i
    topGroup.add(topMesh)
  }
  topGroup.position.y = palletData.top.base
  return topGroup
}

const createPallet = () => {
  const palletGroup = new THREE.Group()
  //create legs
  const legGroup = createLegs()
  const stringerGroup = createStringers()
  const topGroup = createTop()
  palletGroup.add(legGroup)
  palletGroup.add(stringerGroup)
  palletGroup.add(topGroup)
  const box = new THREE.Box3().setFromObject(palletGroup)
  palletGroup.position.x -= box.max.x / 2
  palletGroup.position.z -= box.max.z / 2
  return palletGroup

}


let pallet = null

const rebuildPallet = () => {
    scene.remove(pallet)
    calculatePalletData()
    pallet = createPallet()
    scene.add(pallet)
}

//Size
gui.add(palletData.size, 'length').name('Pallet Length').min(1000).max(2000).step(10).onChange((value) => {
  palletData.top.length = value / 100
  palletData.bottom.length = value / 100
  palletData.size.length = value
  rebuildPallet()
})

gui.add(palletData.size, 'width').name('Pallet Width').min(800).max(1200).step(10).onChange((value) => {
  palletData.stringer.length = value / 100
  palletData.size.width = value
  rebuildPallet()
})

//top
gui.add(palletData.top, 'count').name('Top Count').min(2).max(10).step(1).onChange(() => {
  rebuildPallet()
})
gui.add(palletData.top, 'boardType', ['16x75', '16x100', '18x90', '19x100', '22x100']).name('Top Board Type').onChange((value) => {
  const h_w = value.split('x')
  palletData.top.height = parseInt(h_w[0]) / 100
  palletData.top.width = parseInt(h_w[1]) / 100
  palletData.top.boardType = value
  rebuildPallet()
})

//stringers
gui.add(palletData.stringer, 'count', [3, 5]).name('Stringer Count').onChange(() => {
  rebuildPallet()
})
gui.add(palletData.stringer, 'boardType', ['16x75', '16x100', '18x90', '19x100', '22x100']).name('Stringer Board Type').onChange((value) => {
  const h_w = value.split('x')
  palletData.stringer.height = parseInt(h_w[0]) / 100
  palletData.stringer.width = parseInt(h_w[1]) / 100
  palletData.stringer.boardType = value
  rebuildPallet()
})

//bottom
gui.add(palletData.bottom, 'count').name('Bottom Count').min(2).max(5).step(1).onChange(() => {
  rebuildPallet()
})
gui.add(palletData.bottom, 'boardType', ['16x75', '16x100', '18x90', '19x100', '22x100']).name('Bottom Board Type').onChange((value) => {
  const h_w = value.split('x')
  palletData.bottom.height = parseInt(h_w[0]) / 100
  palletData.bottom.width = parseInt(h_w[1]) / 100
  palletData.bottom.boardType = value
  palletData.block.length = parseInt(h_w[1]) / 100
  rebuildPallet()
})



pallet = createPallet() 

camera.lookAt(pallet)

// pallet.castShadow = true



scene.add(pallet)

/* MAIN LOOP */
const loop = () => {
  //update
  controls.update();

  //animate


  //render

  renderer.render(scene, camera);
  window.requestAnimationFrame(loop);
}

loop()

/* MAIN LOOP END */